import React from 'react';
import Icon from '../../../components/AppIcon';

const DisputeHandling = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-2">Dispute Handling</h2>
        <p className="text-muted-foreground">Manage and resolve platform disputes</p>
      </div>

      <div className="bg-card rounded-lg border border-border p-12 text-center">
        <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircle" size={32} className="text-green-600" />
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">No Active Disputes</h3>
        <p className="text-muted-foreground mb-6">All transactions are proceeding smoothly</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-2xl mx-auto">
          <div className="bg-muted/50 rounded-lg p-4">
            <p className="text-2xl font-bold text-foreground mb-1">0</p>
            <p className="text-xs text-muted-foreground">Open Disputes</p>
          </div>
          <div className="bg-muted/50 rounded-lg p-4">
            <p className="text-2xl font-bold text-foreground mb-1">0</p>
            <p className="text-xs text-muted-foreground">Pending Review</p>
          </div>
          <div className="bg-muted/50 rounded-lg p-4">
            <p className="text-2xl font-bold text-foreground mb-1">0</p>
            <p className="text-xs text-muted-foreground">Resolved Today</p>
          </div>
        </div>
      </div>

      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Dispute Resolution Process</h3>
        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-blue-500/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="FileText" size={16} className="text-blue-600" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Case Submission</p>
              <p className="text-xs text-muted-foreground">Users submit dispute with evidence and details</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-purple-500/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="Search" size={16} className="text-purple-600" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Investigation</p>
              <p className="text-xs text-muted-foreground">Admin reviews transaction history and communications</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-green-500/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="CheckCircle" size={16} className="text-green-600" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">Resolution</p>
              <p className="text-xs text-muted-foreground">Decision made with appropriate compensation or action</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisputeHandling;